import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import TeamDetailTable from './teamDetailTable';
import BasicDetailDrillDown from 'components/basicDetailDrillDown';
import TeamEdit from '../teamMaintenance/teamEdit';
import { getDisplayData } from 'services/teamService';
import SelectByIdModal from 'components/selectByIdModal';
import { sameByIdValue } from 'services/arrayService';
import {
    onEditTeam,
    onTeamSelect,
    showTeamLoader,
    onTeamMemberUpdate,
    onFetchSelectMemberData,
    onDeleteTeam,
} from 'actions/team';
import DeleteItemCheck from 'components/deleteItemCheck';
// import { TIGHT_FIT_PARAM } from 'constants/System';

const TeamDetail = () => {
    // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const allMembers = useSelector(state => state.members.allMember);
    const selectedTeam = useSelector(state => state.teams.selectedTeam);
    const memberSelectionList = useSelector(state => state.teams.memberSelectionList);
    const [selectedMembers, setSelectedMembers] = useState();

    useEffect(() => {
        // update the selectedMembers
        setSelectedMembers([]);
        const members = sameByIdValue(allMembers, selectedTeam?.members);
        setSelectedMembers(members);
    }, [selectedTeam]);

    const mainIcon = () => {
        // TODO pass in type to change the icon on the detail tab
        // if (type && type.toLowerCase() === 'high') {
        //     return 'stream';
        // }
        // if (type && type.toLowerCase() === 'medium') {
        //     return 'compact';
        // }
        // if (type && type.toLowerCase() === 'low') {
        //     return 'module';
        // }
        return 'dashboard';
    };

    if (selectedTeam) {
        // const fields = { ...selectedTeam?.fields };
        const displayData = getDisplayData(selectedTeam);
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-7 col-12">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h2 className="card-heading">{displayData?.name}</h2>
                                </div>
                                <div>
                                    <SelectByIdModal
                                        modalTitle={<IntlMessages id="team.members" />}
                                        onUpdateHandler={onTeamMemberUpdate}
                                        onSelectRowHandler={onTeamSelect}
                                        onClickButtonHandler={onFetchSelectMemberData}
                                        selectLoader={showTeamLoader}
                                        data={memberSelectionList}
                                        width={width}
                                        actionButtonTextId={<IntlMessages id="team.members" />}
                                    />
                                    <DeleteItemCheck
                                        id={selectedTeam?.id}
                                        onConfirm={onDeleteTeam}
                                        alertMessage={<IntlMessages id="team.deleteTeam" />}
                                    />
                                    <Button size="sm" color="primary" onClick={() => dispatch(onEditTeam(selectedTeam))}>
                                        <i className="zmdi zmdi-edit zmdi-hc-fw" />
                                        <span>{<IntlMessages id="label.edit" />}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className="jr-card-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                            <p>
                                                {/* <div className={`btn btn-sm text-uppercase btn-rounded ${style}`}>{order} Order</div> */}
                                                <i className={`detail-icon text-blue-grey zmdi zmdi-view-${mainIcon()} zmdi-hc-fw`} />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-9 text-center text-sm-left">
                                        <TeamDetailTable displayData={displayData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <TeamEdit />
                    </div>

                    <div className="col-md-5">
                        <div className="jr-card jr-card-full-height mr-2 ml-2">
                            <BasicDetailDrillDown entries={selectedMembers} title={<IntlMessages id="team.members" />} />
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="jr-card jr-card-full-height">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h3 className="card-heading">Please select an entry to display details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default TeamDetail;


// WEBPACK FOOTER //
// ./components/Agile/team/teamDetail/index.js